namespace Matrix.Indexation {
    export interface IndexationProfileSecurityListExcelRequest extends Serenity.ServiceRequest {
        IndexationProfileCode?: string;
    }
}
